import H3 from '@shared/typography/H3'
import DashboardMenu from 'app/dashboard/shared/DashboardMenu'
import { User } from '../../../helpers/types'

interface DashboardMobileProps {
  user: User
  pathname: string
}

const DashboardMobile: React.FC<DashboardMobileProps> = ({
  user,
  pathname,
}) => (
  <div className="w-[270px] bg-secondary text-white h-screen overflow-auto px-4 pt-24">
    <H3 className="mb-8">
      {user.firstName} {user.lastName}
    </H3>
    <DashboardMenu pathname={pathname} />
  </div>
)

export default DashboardMobile
